import React, { useEffect, useState } from 'react';
import AdminApi from './AdminApi';

const AdminRolePage = ({ currentMenu, clickChangeMenu, setEditingRole }) => {
    const [roles, setRoles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const data = await AdminApi.getRoles();
            setRoles(data);
        } catch (err) {
            console.error("Error fetching roles:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleDelete = async (id, name) => {
        if (window.confirm(`Bạn có chắc muốn xóa nhóm "${name}"?`)) {
            try {
                await AdminApi.deleteRole(id);
                fetchData();
            } catch (err) {
                alert("Lỗi khi xóa nhóm thành viên");
            }
        }
    };

    const handleEdit = (role) => {
        setEditingRole(role);
        clickChangeMenu('taikhoan-roles-edit');
    };

    const handleAdd = () => {
        setEditingRole(null);
        clickChangeMenu('taikhoan-roles-edit');
    };

    const handlePermissions = (role) => {
        setEditingRole(role);
        clickChangeMenu('taikhoan-roles-permissions');
    };

    return (
        <div className="social-box" style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', margin: '15px' }}>
            <h3 className="page-title" style={{ marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Nhóm thành viên</h3>

            <div className="header" style={{ marginBottom: '15px', display: 'flex', gap: '10px' }}>
                <button className="btn btn-primary" style={{ backgroundColor: '#4b5d73', border: 'none' }} onClick={handleAdd}>
                    <i className="icon-pencil" /> Thêm nhóm thành viên
                </button>
                <button className="btn" onClick={() => clickChangeMenu('taikhoan')}>Quay lại</button>
            </div>

            <div className="body">
                <table className="table table-striped table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>Tên nhóm</th>
                            <th>Thứ tự</th>
                            <th>Mặc định</th>
                            <th>Quản lý</th>
                            <th>Xét duyệt</th>
                            <th>Trụ trì</th>
                            <th>Nội bộ</th>
                            <th width="350px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr><td colSpan="8" className="text-center">Đang tải...</td></tr>
                        ) : (
                            roles.map(role => (
                                <tr key={role.roleid}>
                                    <td>{role.rolename}</td>
                                    <td>{role.order}</td>
                                    <td style={{ textAlign: 'center' }}><input type="checkbox" checked={role.isDefault} readOnly /></td>
                                    <td style={{ textAlign: 'center' }}><input type="checkbox" checked={role.manager} readOnly /></td>
                                    <td style={{ textAlign: 'center' }}><input type="checkbox" checked={role.isxetduyet} readOnly /></td>
                                    <td style={{ textAlign: 'center' }}><input type="checkbox" checked={role.isthay} readOnly /></td>
                                    <td style={{ textAlign: 'center' }}><input type="checkbox" checked={role.isnoibo} readOnly /></td>
                                    <td style={{ textAlign: 'right' }}>
                                        <button className="btn btn-info btn-small" style={{ marginRight: '5px', backgroundColor: '#336699' }} onClick={() => handlePermissions(role)}>
                                            Quyền truy cập
                                        </button>
                                        <button className="btn btn-success btn-small" style={{ marginRight: '5px', backgroundColor: '#5cb85c' }} onClick={() => handleEdit(role)}>
                                            <i className="icon-edit" /> Sửa
                                        </button>
                                        <button className="btn btn-danger btn-small" style={{ backgroundColor: '#d9534f' }} onClick={() => handleDelete(role.roleid, role.rolename)}>
                                            <i className="icon-minus-sign" /> Xóa
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminRolePage;
